import React, { useRef, useState } from 'react';
import LogoHeader from '../IntroStep/LogoHeader';
import { MBTISpectrumHUD } from '../MBTISpectrumHUD';
import './QuestionStep.css';
import type { MBTIScores } from '../../types';
import QuestionProgress from './QuestionProgress';
import QuestionCard from './QuestionCard';

const mockScores: MBTIScores = {
  E: 0.7,
  I: 0.3,
  N: 0.6,
  S: 0.4,
  T: 0.5,
  F: 0.5,
  P: 0.4,
  J: 0.6,
};

const QuestionStepPreview: React.FC = () => {
  const [index, setIndex] = useState(3);
  const [swipeDX, setSwipeDX] = useState(0);
  const [swipeDY, setSwipeDY] = useState(0);
  const touchStartX = useRef<number | null>(null);
  const touchStartY = useRef<number | null>(null);

  const onTouchStart = (event: React.TouchEvent) => {
    const touch = event.changedTouches[0];
    touchStartX.current = touch.clientX;
    touchStartY.current = touch.clientY;
    setSwipeDX(0);
    setSwipeDY(0);
  };

  const onTouchMove = (event: React.TouchEvent) => {
    const touch = event.changedTouches[0];
    if (touchStartX.current == null || touchStartY.current == null) return;
    setSwipeDX(touch.clientX - touchStartX.current);
    setSwipeDY(touch.clientY - touchStartY.current);
  };

  const onTouchEnd = () => {
    setSwipeDX(0);
    setSwipeDY(0);
  };

  const handleBack = () => {
    setIndex((prev) => Math.max(0, prev - 1));
  };

  return (
    <div className="question-step">
      <LogoHeader />
      <div className="question-step-body">
        <div className="question-step-backdrop" />
        <div className="question-step-content">
          <MBTISpectrumHUD scores={mockScores} />
          <div className="question-progress-row">
            <button
              type="button"
              className="question-back-btn"
              onClick={handleBack}
              disabled={index === 0}
            >
              Back
            </button>
            <QuestionProgress progress={index} total={12} />
          </div>
          <div className="question-main">
            <QuestionCard
              text="Do you seek to maintain harmony in groups?"
              swipeDX={swipeDX}
              swipeDY={swipeDY}
              agreeLabel="I AGREE"
              disagreeLabel="I DISAGREE"
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
            />
            <div className="question-actions">
              <button
                type="button"
                className="question-pill question-pill-disagree"
              >
                I DISAGREE
              </button>
              <button
                type="button"
                className="question-pill question-pill-agree"
              >
                I AGREE
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionStepPreview;
